// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"148be9f7","455":"e3e17a0c"}[chunkId] + ".chunk.js";
};